<div class="dialog-container">
  <img alt="" src="/assets/images/logo.svg" />
  <div >
    @if (getError() === '' && ballotType === 'POLL' && this.returnMethod === 'ELECTRONIC') {
      <div>
        <h1 mat-dialog-title i18n id="dialog-title" class="vtz-modal-title">Submit your poll?</h1>
        <mat-dialog-content i18n class="vtz-modal-body iphone-se" id ="dialog-content" >
        Once you click <strong>SUBMIT</strong>, please <strong>DO NOT</strong> refresh, click the browser back button, or close your browser until you receive a confirmation that your responses have been recorded successfully.
      </mat-dialog-content>
      </div>
    } @else if (getError() === '' && ballotType === 'ELECTION' && this.returnMethod === 'ELECTRONIC') {
      <div>
        <h1 mat-dialog-title i18n id="dialog-title" class="vtz-modal-title">Submit your ballot?</h1>
        <mat-dialog-content i18n class="vtz-modal-body iphone-se" id ="dialog-content" >You will not be able to make changes <br/> to your ballot once you submit it.<br>
        Once you click <strong>SUBMIT</strong>, please <strong>DO NOT</strong> refresh, click the browser back button, or close your browser until you receive a confirmation that your vote has been recorded successfully.
      </mat-dialog-content>
      </div>
    } @else if (getError() === '' && ballotType !== 'PETITION' && this.returnMethod === 'PRINT') {
      <div>
        <h1 mat-dialog-title i18n id="dialog-title" class="vtz-modal-title">Continue to the print page?</h1>
        <mat-dialog-content i18n class="vtz-modal-body" id ="dialog-content">Your selections will be marked on a printable PDF.</mat-dialog-content>
      </div>
    } @else if (getError() === '' && ballotType === 'PETITION') {
      <div>
        <h1 mat-dialog-title i18n id="dialog-title" class="vtz-modal-title">Submit your petition?</h1>
        <mat-dialog-content i18n class="vtz-modal-body" id ="dialog-content">You will not be able to make changes <br/> to your petition once you submit it.<br>
        Once you click submit petition, please do not refresh, click the browser back button, or close your browser until you receive a confirmation that your petition has been recorded successfully.</mat-dialog-content>
      </div>
    } @else { 
      <div>
        <h1 mat-dialog-title i18n id="dialog-title" class="vtz-modal-title">Error</h1>
        @if (getError() === 'ELECTION_CLOSED'){
          @if(screenOrder.routeSubmitBallotErrorToDashboard()) {
            <mat-dialog-content i18n class="vtz-modal-body" id ="dialog-content">Your ballot could not be submitted. The election is closed. Please return to the dashboard.</mat-dialog-content>
          } @else {
            <mat-dialog-content i18n class="vtz-modal-body" id ="dialog-content">Your ballot could not be submitted. The election is closed. Please return to the welcome screen.</mat-dialog-content>
          }
        } @else {
          @if(screenOrder.routeSubmitBallotErrorToDashboard()) {
            <mat-dialog-content i18n class="vtz-modal-body" id ="dialog-content">Please return to the dashboard.</mat-dialog-content>
          } @else {
            <mat-dialog-content i18n class="vtz-modal-body" id ="dialog-content">Please return to the welcome screen and try again.</mat-dialog-content>
          }
        }
      </div>
    }
  </div>
  @if (getError() === '') {
    <div>
      <mat-dialog-actions >
        <div class="dialog-button-container">
          <button i18n class="button-secondary button-narrow-screen" mat-dialog-close>BACK</button>
          <div class="vtz-spacer-10"></div>
          @if (this.returnMethod==='ELECTRONIC') {
            <button i18n class="button-primary button-narrow-screen" cdkFocusInitial id="submit-ballot"
            aria-describedby="dialog-title dialog-content" (click)="submit()">SUBMIT</button>
          }
          @if (this.returnMethod==='PRINT') {
            <button i18n class="button-primary button-narrow-screen" cdkFocusInitial
            aria-describedby="dialog-title dialog-content" (click)="submit()">CONTINUE</button>
          }
        </div>
      </mat-dialog-actions>
    </div>
  }
  @if (getError() !== '') {
    <div>
      <mat-dialog-actions class="dialog-button-container">
        <button i18n class="button-primary" mat-dialog-close>OK</button>
      </mat-dialog-actions>
    </div>
  }

  @if (displayProgressSpinner) {
    <div class="progressSpinner" >
      <mat-spinner [diameter]="300" color="primary" ></mat-spinner>
      <div class="spinner-warning">
        <p i18n>Please do not refresh, click the browser back button, or close your browser.</p>
      </div>
    </div>
  }
</div>
<app-ballot-error-modal [isBallotError]="isBallotError" [error]="error" [ballotType]="ballotType" [useEmail]="useEmail()"></app-ballot-error-modal>
